const config = (zoom = 12, center = { lat: 51.647573, lng: 5.201691 }) => {
    return {
        zoom: zoom,
        center: center,
        /* based on first location will be overruled by fitbounds */
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        styles: [
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [
                    {
                        hue: "#ffbb00"
                    },
                    {
                        saturation: 43.400000000000006
                    },
                    {
                        lightness: 37.599999999999994
                    },
                    {
                        gamma: 1
                    },
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "landscape.natural",
                elementType: "all",
                stylers: [
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "poi",
                elementType: "all",
                stylers: [
                    {
                        hue: "#00ff6a"
                    },
                    {
                        saturation: -1.0989010989011234
                    },
                    {
                        lightness: 11.200000000000017
                    },
                    {
                        gamma: 1
                    },
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "poi.attraction",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.business",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.government",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.medical",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.park",
                elementType: "all",
                stylers: [
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "poi.place_of_worship",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.school",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "poi.sports_complex",
                elementType: "all",
                stylers: [
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "road.highway",
                elementType: "all",
                stylers: [
                    {
                        hue: "#FFC200"
                    },
                    {
                        saturation: -61.8
                    },
                    {
                        lightness: 45.599999999999994
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "road.arterial",
                elementType: "all",
                stylers: [
                    {
                        hue: "#FF0300"
                    },
                    {
                        saturation: -100
                    },
                    {
                        lightness: 51.19999999999999
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "road.local",
                elementType: "all",
                stylers: [
                    {
                        hue: "#FF0300"
                    },
                    {
                        saturation: -100
                    },
                    {
                        lightness: 52
                    },
                    {
                        gamma: 1
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "all",
                stylers: [
                    {
                        hue: "#0078FF"
                    },
                    {
                        saturation: -13.200000000000003
                    },
                    {
                        lightness: 2.4000000000000057
                    },
                    {
                        gamma: 1
                    }
                ]
            }
        ]
    };
};

export default config;
